import api from '@/store/api';
import { athena, boro } from '@/store/api/instances';
import type { OpsService } from '@/types/configs';
import type { ApiListingRequest, ApiResponse } from '@bitstopco/bitstop-theme';

interface CreateOpsServiceRequest {
  name: string;
  description: string;
}

interface UpdateOpsServiceRequest {
  id: string;
  name: string;
  description: string;
  is_active?: boolean;
}

/**
 * RTK Query API for Ops Services.
 */
export const opsServicesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getOpsServices: build.query<ApiResponse<OpsService[]>, ApiListingRequest | void>({
      query: (data) =>
        athena({
          url: 'v2/operations/ops-services',
          method: 'POST',
          data: data || {
            pagination: {
              current_page: 1,
              items_per_page: 1000,
              sort_by: 'name',
              sort_ascending: true,
            },
          },
        }),
      providesTags: ['OpsServices'],
    }),
    createOpsService: build.mutation<ApiResponse<OpsService>, CreateOpsServiceRequest>({
      query: (data) =>
        boro({
          url: 'v2/operations/ops-services',
          method: 'POST',
          data,
        }),
      invalidatesTags: ['OpsServices'],
    }),
    updateOpsService: build.mutation<ApiResponse<OpsService>, UpdateOpsServiceRequest>({
      query: ({ id, ...data }) =>
        boro({
          url: `v2/operations/ops-services/${id}`,
          method: 'PATCH',
          data,
        }),
      invalidatesTags: ['OpsServices'],
    }),
    deleteOpsService: build.mutation<void, string>({
      query: (id) =>
        boro({
          url: `v2/operations/ops-services/${id}`,
          method: 'DELETE',
        }),
      invalidatesTags: ['OpsServices'],
    }),
  }),
});

export const {
  useGetOpsServicesQuery,
  useCreateOpsServiceMutation,
  useUpdateOpsServiceMutation,
  useDeleteOpsServiceMutation,
} = opsServicesApi;
